import { render } from "./PositionAndDevice.vue?vue&type=template&id=bb954492&scoped=true"
import script from "./PositionAndDevice.vue?vue&type=script&lang=js"
export * from "./PositionAndDevice.vue?vue&type=script&lang=js"

import "./PositionAndDevice.vue?vue&type=style&index=0&id=bb954492&lang=scss&scoped=true"
import "./PositionAndDevice.vue?vue&type=style&index=1&id=bb954492&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb954492"]])

export default __exports__